import functions from './functions';

$(() => {
    listActivities.init();
});

const listActivities = {
    $container: null,
    page: 1,
    init() {
        listActivities.$container = $('.list-activities');

        if (! listActivities.$container.length) {
            return;
        }

        listActivities.page = parseInt(functions.getUrlData(true).page, 10) || 1;

        listActivities.fetchList();
        listActivities.bindEvents();
    },
    bindEvents() {
        $(document).on('click', '.list-activities .list-pagination [data-page]', e => {
            e.preventDefault();
            const page = parseInt(e.currentTarget.getAttribute('data-page'), 10);

            if (! page || page === listActivities.page) {
                return;
            }

            listActivities.page = page;
            listActivities.fetchList();
            functions.scrollToElement(listActivities.$container, 100);
        });
    },
    // 12 on desktop, 8 on mobile (screenshot spec) - decided client-side since
    // it depends on viewport width, then sent as a real perPage param so the
    // server-side pagination math (total pages, from/to counts) matches it.
    perPage() {
        return functions.smallWin() ? 8 : 12;
    },
    skeletonCard() {
        return '<div class="col"><div class="card card-locality skeleton-block"></div></div>';
    },
    fetchList() {
        functions.setUrlData({ page: listActivities.page }, true);

        listActivities.$container.find('.list-items').html(
            '<div class="list-meta"><div class="skeleton-line skeleton-line--total"></div></div>'
            + '<div class="row row-cols-2 row-cols-lg-4 g-3">' + listActivities.skeletonCard().repeat(listActivities.perPage()) + '</div>'
        );

        return $.getJSON(
            location.protocol
            + '//'
            + location.hostname
            + '/services/list/?'
            + 'objectGroupId=10&template=activities&objectTypeId=36'
            + '&page=' + listActivities.page
            + '&perPage=' + listActivities.perPage()
        ).done(response => {
            listActivities.$container.find('.list-items').html(response.html);
            window.observer.observe();
        });
    },
};

export {
    listActivities,
};
